import { ReactElement, useEffect, useState } from 'react';

import { useHireBussinessPlanForm } from '../../../contexts/HirePlanBussinessFormProvider';
import { Input } from '../../Input';
import { Select } from '../../Select';
import { GoForwardButton } from '../GoForwardButton';
import { useRouteLoaderData } from 'react-router-dom';
import { validateCEP } from '../../../utils/ValidateCEP';
import {
  changeCivilStatus,
  changeGender,
  changeIssuingAgency,
  changeUF,
} from '../../../utils/ChangeArrays';
import { usePlanLoadingStore } from '../../../stores/usePlanLoadingStore';
import { validateCPF } from '../../../utils/ValidateCPF';
import { useNortheastPlanDataStore } from '../../../stores/useNortheastPlanDataStore';
import { fetchPlan } from '../../../requests/requests';
import {
  BussinessTypeRangeLives1Ids,
  BussinessTypeRangeLives1Tokens,
  BussinessTypeRangeLives2Ids,
  BussinessTypeRangeLives2Tokens,
  IndividualWithShortageNorthEastTokens,
} from '../../../utils/Enums/Tokens';
import { getSiglaSeExistir } from '../../../utils/getSiglaIfExists';
import { useBoostedPlanDataStore } from '../../../stores/useBoostedPlanDataStore';

export function BussinessRegisterForm(): ReactElement {
  const { register, handleSubmit, goToNextForm, errors, watch, setValue } =
    useHireBussinessPlanForm();
  const initialPlanData: any = useRouteLoaderData('token-empresa');
  const northeastPlanData = useNortheastPlanDataStore(state => state.data);
  const setNortheastPlanData = useNortheastPlanDataStore(
    state => state.setNortheastPlanData,
  );
  const setBoostPlanData = useBoostedPlanDataStore(x => x.setBoostPlanData);
  const setLoading = usePlanLoadingStore(state => state.setLoading);

  useEffect(() => {
    setLoading(false);
  }, []);

  const CEP = watch('user.address.cep');
  const CPF = watch('user.documents.cpf');
  const UF = watch('user.address.uf');
  const city = watch('user.address.city');
  const neighborhood = watch('user.address.neighborhood');
  const street = watch('user.address.street');

  const [data, setData] = useState(initialPlanData);
  const [newData, setnewData] = useState({});

  async function handleCEPChange(NE: boolean) {
    const vendedorId = initialPlanData.vendedorId;
    switch (initialPlanData.token) {
      case BussinessTypeRangeLives1Tokens.CLINICO:
      case BussinessTypeRangeLives1Tokens.CLINICO_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives1Ids.CLINICO_NE
            : BussinessTypeRangeLives1Ids.CLINICO,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives1Tokens.ORTO:
      case BussinessTypeRangeLives1Tokens.ORTO_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives1Ids.ORTO_NE
            : BussinessTypeRangeLives1Ids.ORTO,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives1Tokens.DOC:
      case BussinessTypeRangeLives1Tokens.DOC_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives1Ids.DOC_NE
            : BussinessTypeRangeLives1Ids.DOC,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives2Tokens.CLINICO:
      case BussinessTypeRangeLives2Tokens.CLINICO_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives2Ids.CLINICO_NE
            : BussinessTypeRangeLives2Ids.CLINICO,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives2Tokens.ORTO:
      case BussinessTypeRangeLives2Tokens.ORTO_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives2Ids.ORTO_NE
            : BussinessTypeRangeLives2Ids.ORTO,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives2Tokens.DOC:
      case BussinessTypeRangeLives2Tokens.DOC_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives2Ids.DOC_NE
            : BussinessTypeRangeLives2Ids.DOC,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
    }
  }

  const getCEPDetails = async (e: string) => {
    const formatedCep = e.replace(/[^0-9]/g, '');
    if (formatedCep.length < 8) {
      return;
    }
    const CEPInformations = await fetch(
      `${process.env.REACT_APP_URL_BASE}/api/redeatendimento/Endereco?token=${process.env.REACT_APP_TOKEN_S4E_V2}&cep=${formatedCep}`,
      {
        method: 'POST',
      },
    ).then(response => response.json());

    setLoading(false);
    const NORDESTE_UFS = ['AL', 'PB', 'PE', 'RN', 'CE', 'BA', 'SE', 'MA', 'PI'];
    if (CEPInformations.dados == null) {
      alert('cep não encontrado na Base');
    }
    const SiglaUf = getSiglaSeExistir(CEPInformations.dados.Uf);
    console.log('SiglaUf: ', SiglaUf);
    if (!SiglaUf) {
      alert('Não foi possivel encontrar a UF correspondente ao CEP informado');
      setValue('user.address.cep', '');
      return;
    } else {
      handleCEPChange(NORDESTE_UFS.includes(SiglaUf));
    }
    console.log('cep: ', CEPInformations);
    const UF = initialPlanData.listaUFS.find(x => x.sigla == SiglaUf).Id;
    setValue('user.address.city', CEPInformations.dados.Municipio);
    setValue('user.address.neighborhood', CEPInformations.dados.Bairro);
    setValue('user.address.street', CEPInformations.dados.Logradouro);
    setValue('user.address.uf', String(UF));

    return CEPInformations;
  };

  useEffect(() => {
    if (Object.keys(newData).length !== 0 && newData != data) {
      setData(newData);
    }
  }, [newData]);

  useEffect(() => {
    if (CEP && validateCEP.test(CEP)) {
      getCEPDetails(CEP);
    }
  }, [CEP]);

  useEffect(() => {
    if (Object.keys(northeastPlanData).length === 0) {
      setNortheastPlanData({ ...initialPlanData });
    }
    console.log('initialPlanData: ', initialPlanData);
  }, []);
  changeUF(data.listaUFS);
  changeGender(data.listaSexos);
  changeIssuingAgency(data.listaOrgaosExpedidor);
  changeCivilStatus(data.listaEstadosCivil);
  return (
    <form
      action=""
      className="max-w-[766px] w-full"
      onSubmit={handleSubmit(goToNextForm)}
    >
      <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8">
        Dados Empresa
      </h2>

      <div className="grid min-[748px]:grid-cols-2 grid-cols-1 gap-6">
        <Input
          activateMask
          mask="99999-999"
          label="CEP"
          className="w-full"
          //onBlur={e => getPlanValueByCEP(e.target.value)}
          placeholder="CEP"
          errorMessage={errors.user?.address?.cep?.message}
          {...register('user.address.cep')}
        />
        <Input
          label="CNPJ"
          placeholder="CNPJ"
          activateMask
          mask="99.999.999/9999-99"
          errorMessage={errors.user?.documents?.cnpj?.message}
          {...register('user.documents.cnpj')}
        />
        <Input
          label="Razão Social"
          placeholder="Razão Social"
          errorMessage={errors.user?.razSoc?.message}
          {...register('user.razSoc')}
        />
        <Input
          label="Inscrição Estadual"
          placeholder="Inscrição Estadual"
          errorMessage={errors.user?.stateInscription?.message}
          {...register('user.stateInscription')}
        />
        <Input
          label="Número de Funcionários"
          placeholder="Número de Funcionários"
          errorMessage={errors.user?.functionaryQuantity?.message}
          {...register('user.functionaryQuantity')}
        />
      </div>
      <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8 mt-16">
        Dados do Responsável pela empresa
      </h2>
      <div className="grid min-[748px]:grid-cols-1 grid-cols-1 gap-6">
        <div className="grid grid-cols-3 gap-8">
          <div className="min-[748px]:col-span-2">
            <Input
              label="Nome completo"
              placeholder="Nome completo"
              errorMessage={errors.user?.fullName?.message}
              {...register('user.fullName')}
            />
          </div>
          <Input
            activateMask
            mask="99/99/9999"
            label="Data de nascimento"
            placeholder="dd/mm/aaaa"
            errorMessage={errors?.user?.birthDate?.message}
            {...register(`user.birthDate`)}
          />
        </div>
        <div className="grid grid-cols-3 gap-8">
          <Input
            label="CPF"
            placeholder="CPF"
            onBlur={validateCPF}
            activateMask
            mask="999.999.999-99"
            errorMessage={errors.user?.documents?.cpf?.message}
            {...register('user.documents.cpf')}
          />
          <Input
            label="E-mail"
            placeholder="E-mail"
            errorMessage={errors.user?.email?.message}
            {...register('user.email')}
          />
          <Input
            label="Telefone"
            activateMask
            mask="(99) 99999-9999"
            placeholder="Telefone"
            errorMessage={errors.user?.phone?.message}
            {...register('user.phone')}
          />
        </div>
        <Input
          label="Logradouro"
          //value={street}
          placeholder="Digite o seu logradouro"
          errorMessage={errors.user?.address?.street?.message}
          {...register('user.address.street')}
        />
        <div className="grid grid-cols-2 gap-8">
          <Input
            label="Complemento"
            placeholder="Digite o seu complemento"
            errorMessage={errors.user?.address?.complement?.message}
            {...register('user.address.complement')}
          />
          <Input
            label="Número"
            //type="number"
            placeholder="Digite o seu número"
            errorMessage={errors.user?.address?.number?.message}
            {...register('user.address.number')}
          />
        </div>
        <div className="grid grid-cols-3 gap-8">
          <Input
            label="Bairro"
            //value={neighborhood}
            placeholder="Digite o seu bairro"
            errorMessage={errors.user?.address?.neighborhood?.message}
            {...register('user.address.neighborhood')}
          />
          <Input
            label="Cidade"
            //value={city}
            placeholder="Digite sua cidade"
            errorMessage={errors.user?.address?.city?.message}
            {...register('user.address.city')}
          />
          <Select
            label="UF"
            options={[]}
            optionsFull={data.listaUFS}
            placeholder="UF"
            errorMessage={errors.user?.address?.uf?.message}
            {...register('user.address.uf')}
          />
        </div>
      </div>
      <GoForwardButton />
    </form>
  );
}
